module.exports = __webpack_public_path__ + "img/es0.2376ad06.jpg";